import SearchCardManager from './SectionManager';
import AppsSection from './help/AppsSection';
import ChannelsSection from './help/ChannelsSection';
import ShowMovieSection from './help/ShowMovieSection';

export { AppsSection, ChannelsSection, ShowMovieSection };
export default SearchCardManager;
